import { UIHeading5, UIText2, IconReload16 } from '@cian/ui-kit';
import classNames from 'classnames';
import * as React from 'react';

import * as styles from './OfferMessage.css';

type TOfferMessageProps = {
  isOutcoming: boolean;
  withReload: boolean;
  formattedAddress: string;
  formattedInfo: string;
  formattedPrice: string;
  formattedOldPrice?: string;
  shareUrl: string;
  photoUrl?: string;
  onReload(): void;
  onClick(): void;
};

export const OfferMessage: React.FC<TOfferMessageProps> = ({
  isOutcoming,
  withReload,
  formattedAddress,
  formattedInfo,
  formattedPrice,
  formattedOldPrice,
  shareUrl,
  photoUrl,
  onReload,
  onClick,
}) => {
  return (
    <div
      className={classNames(styles['container'], withReload && !photoUrl && styles['container-short'])}
      data-name={`OfferMessage_${isOutcoming ? 'outcoming' : 'incoming'}`}
    >
      {photoUrl && (
        <a className={styles['image-container']} onClick={onClick} href={shareUrl} target="_blank">
          <img data-name="OfferMessage_image" src={photoUrl} className={styles['image']} alt="Фото объявления" />
          {withReload && onReload && (
            <div onClick={onReload} className={styles['image-reload-button']}>
              <IconReload16 color="white_100" />
            </div>
          )}
        </a>
      )}
      {withReload && onReload && !photoUrl && (
        <div onClick={onReload} className={styles['reload-button']}>
          <IconReload16 color="white_100" />
        </div>
      )}
      <a onClick={onClick} href={shareUrl} className={styles['content']} target="_blank">
        <div className={styles['price']} data-name="OfferMessage_price">
          <UIHeading5 color={isOutcoming ? 'white_100' : 'black_100'}>{formattedPrice}</UIHeading5>
          <s
            className={classNames(
              styles['formatted_old_price'],
              isOutcoming && styles['formatted_old_price_outcoming'],
            )}
          >
            <UIText2 color={isOutcoming ? 'white_60' : 'gray60_100'}>{formattedOldPrice}</UIText2>
          </s>
        </div>
        <div className={styles['info']}>
          <UIText2 color={isOutcoming ? 'white_100' : 'gray60_100'} data-name="OfferMessage_info">
            {formattedInfo}
          </UIText2>
          <UIText2 color={isOutcoming ? 'white_100' : 'gray60_100'} data-name="OfferMessage_address">
            {formattedAddress}
          </UIText2>
        </div>
      </a>
    </div>
  );
};
